/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { EvidencePart } from "@interfaces/Interfaces";
import { IonItem } from "@ionic/react";
import { Button_Checkbox_Active, Button_Checkbox_Inactive } from "@assets/images";
import "./EvidenceParts.css";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  definition: EvidencePart;
  onValueChanged?: (value: any) => void;
  data?: any;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue?: any;
};

const TickBoxList: React.FC<Props> = ({
  definition,
  onValueChanged,
  data,
  isDisplay,
  isPDF,
  pdfStyles,
  initialValue,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(initialValue || []);
  const [listValues, setListValues] = useState<string[]>([]);

  const allSelected = listValues.every((item) => selectedValues.includes(item));

  useEffect(() => {
    const getListValues = (): void => {
      const values = definition?.["List of values"];

      if (values && values.length > 0) {
        let strings = values.split("\n");
        strings = strings.filter((item) => item.length > 0);

        setListValues(strings);
      }
    };

    definition && getListValues();
  }, [definition]);

  const toggleValue = (value: string): void => {
    let array = _.cloneDeep(selectedValues);

    if (!Array.isArray(array)) {
      array = [array];
    }

    if (array.includes(value)) {
      array = array.filter((item) => item !== value);
    } else {
      array.push(value);
    }

    setSelectedValues(array);
    onValueChanged && onValueChanged(array);
  };

  const selectAllPressed = (): void => {
    if (allSelected) {
      setSelectedValues([]);
      onValueChanged?.([]);
    } else {
      setSelectedValues([...listValues]);
      onValueChanged?.([...listValues]);
    }
  };

  if (isPDF) {
    if (!data || data?.length === 0) {
      return null;
    }

    return (
      <View>
        <Text style={pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(definition)}</Text>
        <Text style={pdfStyles.evidenceDate}>{Array.isArray(data) ? [...data]?.sort().join(", ") : data}</Text>
      </View>
    );
  }

  if (isDisplay) {
    if (!data || data?.length === 0) {
      return null;
    }

    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{definition["Display Title"] || definition.Name}</div>
        <div className="readEvidenceText">{Array.isArray(data) ? [...data].sort().join(", ") : data}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {listValues.length > 1 && (
        <div className="flex flex-row justify-end mb-2 mt-2">
          <button
            className="text-17px leading-default tracking-[-0.3] text-cta-blue"
            onClick={() => selectAllPressed()}
          >
            {allSelected ? "Deselect all" : "Select all"}
          </button>
        </div>
      )}
      {listValues.map((item) => {
        const selected = selectedValues.includes(item);

        return (
          <IonItem
            button
            detail={false}
            key={item}
            className="evidencePartsCheckboxContainer"
            onClick={() => toggleValue(item)}
          >
            <div className="evidencePartsCheckboxContainerInner">
              <div className={`evidencePartsCheckboxLabel py-1 ${selected ? "font-semibold" : ""}`}>{item}</div>
              <img
                alt=""
                className="evidencePartsRadioCheckbox"
                src={selected ? Button_Checkbox_Active : Button_Checkbox_Inactive}
              />
            </div>
          </IonItem>
        );
      })}
    </div>
  );
};

export default TickBoxList;
